<template>
  <h1>{{ title }}</h1>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: String,
  },
};
</script>

<style lang="scss">
  h1 {

  }
</style>
